import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  inject,
} from '@angular/core';
import { MemoList } from '../../../model/memo.model';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MemoRemindModalComponent } from '../../memo-remind-modal/memo-remind-modal.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MoveToFolderComponent } from 'src/app/modules/folder/components/folder-item-action/move-to-folder/move-to-folder.component';
import { ActionMenu } from '../../../model/dropdown.model';

@Component({
  selector: 'app-memo-list-action-menus',
  templateUrl: './memo-list-action-menus.component.html',
  styleUrls: ['./memo-list-action-menus.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    MoveToFolderComponent,
    NgbModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MemoListActionMenusComponent implements OnInit {
  @Input() memo?: MemoList;
  @Input() showDetailMenu = false;
  @Input() showEditMenu = false;
  @Input() showDuplicateMenu = false;
  @Input() showRemindMenu = false;
  @Input() showResetPasswordMenu = false;
  @Input() showDeleteMenu = false;
  @Input() showResetOTPMenu = false;
  @Input() showDownloadMenu = false;
  @Input() showFolderMenu = false;
  @Input() customMinWidth: number;

  @Input() detailMenuTitle?: string;
  @Input() detailMenuIcon?: string;

  @Output() deleteClick = new EventEmitter();
  @Output() detailClick = new EventEmitter();
  @Output() downloadClick = new EventEmitter();
  @Output() duplicateClick = new EventEmitter();
  @Output() editClick = new EventEmitter();
  @Output() moveToFolderClick = new EventEmitter();
  @Output() resetOTPClick = new EventEmitter();
  @Output() resetPasswordClick = new EventEmitter();

  private modalService = inject(NgbModal);
  actions: ActionMenu[] = [];

  ngOnInit(): void {
    this.initActionMenus();
  }

  initActionMenus() {
    this.actions = [
      {
        condition: () => this.showDetailMenu,
        title: this.detailMenuTitle ?? 'MEMOS.ACTION-BUTTON.DETAIL',
        iconPath:
          this.detailMenuIcon ??
          'assets/images/icons/body/eye-half.svg#eye-half',
        click: () => this.detailClick.emit(),
      },
      {
        condition: () => this.showEditMenu,
        title: 'COMMON.Edit',
        iconPath: 'assets/images/icons/editing/pencil.svg#pencil',
        click: () => this.editClick.emit(),
      },
      {
        condition: () => this.showDuplicateMenu,
        title: 'MEMOS.ACTION-BUTTON.Duplicate',
        iconPath: 'assets/images/icons/files/copy.svg#copy',
        click: () => this.duplicateClick.emit(),
      },
      {
        condition: () => this.showRemindMenu,
        title: 'MEMOS.ACTION-BUTTON.Remind',
        iconPath:
          'assets/images/icons/communications/paper-plane.svg#paper-plane',
        click: () => this.openRemindModal(),
      },
      {
        condition: () => this.showResetPasswordMenu,
        title: 'CREATE-USER.Reset password',
        iconPath:
          'assets/images/icons/securities/key-skeleton.svg#key-skeleton',
        click: () => this.resetPasswordClick.emit(),
      },
      {
        condition: () => this.showResetOTPMenu,
        title: 'CREATE-USER.reset OTP',
        iconPath:
          'assets/images/icons/documents/doc-shield.svg#doc-shield',
        click: () => this.resetOTPClick.emit(),
      },
      {
        condition: () => this.showDeleteMenu,
        title: 'COMMON.Delete',
        iconPath: 'assets/images/icons/editing/trash.svg#trash',
        click: () => this.deleteClick.emit(),
      },
      {
        condition: () => this.showDownloadMenu,
        title: 'COMMON.Download',
        iconPath:
          'assets/images/icons/arrows/arrow-down-to-line.svg#arrow-down-to-line',
        click: () => this.downloadClick.emit(),
      },
    ];
  }

  openRemindModal() {
    const modalRef = this.modalService.open(
      MemoRemindModalComponent,
      {
        centered: true,
        size: 'size-smax56',
      },
    );
    modalRef.componentInstance.memo = this.memo;
  }
}
